/* eslint-disable @typescript-eslint/no-explicit-any */
// AgentOps widget registry entries (simple definitions for the widget picker / registry).
// These are distinct from the rich AGENTOPS_WIDGETS in agentopsWidgets.ts which include getData functions.

import {
  REGISTRY_WIDGET_CATEGORIES,
  REGISTRY_WIDGET_SIZES,
  REGISTRY_WIDGET_TYPES,
  REGISTRY_ICONS,
} from './widgetRegistryConstants';

const C = REGISTRY_WIDGET_CATEGORIES;
const S = REGISTRY_WIDGET_SIZES;
const T = REGISTRY_WIDGET_TYPES;

export const AGENTOPS_REGISTRY_WIDGETS = [
  // AGENTOPS WIDGETS
  {
    id: 'agent-runs-count',
    name: 'Total Agent Runs',
    category: C.AGENTOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'All agent executions',
    icon: REGISTRY_ICONS.FiCpu,
    dataSource: 'agentops',
    refreshRate: 60000,
    supportsDateFilter: true
  },
  {
    id: 'agentops-active-runs',
    name: 'Active Runs',
    category: C.AGENTOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Currently running agents',
    icon: REGISTRY_ICONS.FiPlay,
    dataSource: 'agentops',
    refreshRate: 30000,
    supportsDateFilter: false
  },
  {
    id: 'agent-success-rate',
    name: 'Success Rate',
    category: C.AGENTOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Successful run percentage',
    icon: REGISTRY_ICONS.FiCheckCircle,
    dataSource: 'agentops',
    refreshRate: 60000,
    supportsDateFilter: true
  },
  {
    id: 'agentops-total-tools',
    name: 'Total Tools',
    category: C.AGENTOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Unique tools available',
    icon: REGISTRY_ICONS.FiTool,
    dataSource: 'agentops',
    refreshRate: 300000,
    supportsDateFilter: false
  },
  {
    id: 'agentops-safety-violations',
    name: 'Safety Violations',
    category: C.AGENTOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Policy violations detected',
    icon: REGISTRY_ICONS.FiAlertTriangle,
    dataSource: 'agentops',
    refreshRate: 60000,
    supportsDateFilter: true
  },
  {
    id: 'safety-score',
    name: 'Safety Score',
    category: C.AGENTOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Overall safety compliance',
    icon: REGISTRY_ICONS.FiShield,
    dataSource: 'agentops',
    refreshRate: 60000,
    supportsDateFilter: true
  },
  {
    id: 'agentops-health-score',
    name: 'Health Score',
    category: C.AGENTOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'APM health indicator',
    icon: REGISTRY_ICONS.FiHeart,
    dataSource: 'agentops',
    refreshRate: 60000,
    supportsDateFilter: false
  },
  {
    id: 'agentops-heap-usage',
    name: 'Heap Usage',
    category: C.AGENTOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Memory heap utilization',
    icon: REGISTRY_ICONS.FiDatabase,
    dataSource: 'agentops',
    refreshRate: 60000,
    supportsDateFilter: false
  },
  {
    id: 'agentops-cpu-usage',
    name: 'CPU Usage',
    category: C.AGENTOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'CPU utilization percentage',
    icon: REGISTRY_ICONS.FiCpu,
    dataSource: 'agentops',
    refreshRate: 60000,
    supportsDateFilter: false
  },
  {
    id: 'tool-usage',
    name: 'Tool Usage',
    category: C.AGENTOPS,
    type: T.CHART,
    defaultSize: S.MEDIUM,
    description: 'Most used agent tools',
    icon: REGISTRY_ICONS.FiTool,
    dataSource: 'agentops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'agentops-runs-timeline',
    name: 'Runs Over Time',
    category: C.AGENTOPS,
    type: T.CHART,
    defaultSize: S.MEDIUM,
    description: 'Agent runs timeline',
    icon: REGISTRY_ICONS.FiTrendingUp,
    dataSource: 'agentops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'agentops-tool-success',
    name: 'Tool Success Rate',
    category: C.AGENTOPS,
    type: T.CHART,
    defaultSize: S.MEDIUM,
    description: 'Success rate by tool',
    icon: REGISTRY_ICONS.FiBarChart2,
    dataSource: 'agentops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'agentops-incidents',
    name: 'Recent Incidents',
    category: C.AGENTOPS,
    type: T.LIST,
    defaultSize: S.MEDIUM,
    description: 'Latest safety incidents',
    icon: REGISTRY_ICONS.FiAlertOctagon,
    dataSource: 'agentops',
    refreshRate: 60000,
    supportsDateFilter: true
  },
  {
    id: 'agentops-top-agents',
    name: 'Top Agents',
    category: C.AGENTOPS,
    type: T.LIST,
    defaultSize: S.MEDIUM,
    description: 'Most active agents',
    icon: REGISTRY_ICONS.FiUser,
    dataSource: 'agentops',
    refreshRate: 300000,
    supportsDateFilter: true
  },

  // AGENTOPS WIDGETS (Additional)
  {
    id: 'avg-run-duration-agent',
    name: 'Avg Agent Duration',
    category: C.AGENTOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Average execution time',
    icon: REGISTRY_ICONS.FiClock,
    dataSource: 'agentops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'tool-calls-count',
    name: 'Tool Calls',
    category: C.AGENTOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Total tool invocations',
    icon: REGISTRY_ICONS.FiTool,
    dataSource: 'agentops',
    refreshRate: 60000,
    supportsDateFilter: true
  },
  {
    id: 'active-incidents',
    name: 'Active Incidents',
    category: C.AGENTOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Open incident count',
    icon: REGISTRY_ICONS.FiAlertOctagon,
    dataSource: 'agentops',
    refreshRate: 60000,
    supportsDateFilter: false
  },
  {
    id: 'runs-by-outcome',
    name: 'Runs by Outcome',
    category: C.AGENTOPS,
    type: T.CHART,
    defaultSize: S.MEDIUM,
    description: 'Success/Failed/Timeout breakdown',
    icon: REGISTRY_ICONS.FiBarChart2,
    dataSource: 'agentops',
    refreshRate: 60000,
    supportsDateFilter: true
  },
  {
    id: 'memory-usage',
    name: 'Memory Usage',
    category: C.AGENTOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Agent memory consumption',
    icon: REGISTRY_ICONS.FiCpu,
    dataSource: 'agentops',
    refreshRate: 60000,
    supportsDateFilter: false
  },
  {
    id: 'agent-types',
    name: 'Agent Types',
    category: C.AGENTOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Unique agent types',
    icon: REGISTRY_ICONS.FiCpu,
    dataSource: 'agentops',
    refreshRate: 600000,
    supportsDateFilter: false
  },
  {
    id: 'total-steps',
    name: 'Total Steps',
    category: C.AGENTOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Agent steps executed',
    icon: REGISTRY_ICONS.FiActivity,
    dataSource: 'agentops',
    refreshRate: 60000,
    supportsDateFilter: true
  },
  {
    id: 'avg-steps-per-run',
    name: 'Avg Steps/Run',
    category: C.AGENTOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Average steps per run',
    icon: REGISTRY_ICONS.FiBarChart2,
    dataSource: 'agentops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'memory-store-size',
    name: 'Memory Store',
    category: C.AGENTOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Total memory entries',
    icon: REGISTRY_ICONS.FiCpu,
    dataSource: 'agentops',
    refreshRate: 300000,
    supportsDateFilter: false
  },
  {
    id: 'guardrail-triggers',
    name: 'Guardrail Triggers',
    category: C.AGENTOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Safety checks triggered',
    icon: REGISTRY_ICONS.FiShield,
    dataSource: 'agentops',
    refreshRate: 60000,
    supportsDateFilter: true
  },
  {
    id: 'incident-severity',
    name: 'Incident Severity',
    category: C.AGENTOPS,
    type: T.CHART,
    defaultSize: S.MEDIUM,
    description: 'Incidents by severity',
    icon: REGISTRY_ICONS.FiAlertTriangle,
    dataSource: 'agentops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'parallel-executions',
    name: 'Parallel Executions',
    category: C.AGENTOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Concurrent agent runs',
    icon: REGISTRY_ICONS.FiZap,
    dataSource: 'agentops',
    refreshRate: 60000,
    supportsDateFilter: false
  },
  {
    id: 'retry-count',
    name: 'Retry Count',
    category: C.AGENTOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Failed attempts retried',
    icon: REGISTRY_ICONS.FiRefreshCw,
    dataSource: 'agentops',
    refreshRate: 60000,
    supportsDateFilter: true
  },
  {
    id: 'timeout-rate',
    name: 'Timeout Rate',
    category: C.AGENTOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Execution timeouts',
    icon: REGISTRY_ICONS.FiClock,
    dataSource: 'agentops',
    refreshRate: 60000,
    supportsDateFilter: true
  },
  {
    id: 'tool-errors',
    name: 'Tool Errors',
    category: C.AGENTOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Tool invocation failures',
    icon: REGISTRY_ICONS.FiXCircle,
    dataSource: 'agentops',
    refreshRate: 60000,
    supportsDateFilter: true
  },
  {
    id: 'context-window-usage',
    name: 'Context Window',
    category: C.AGENTOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Context utilization %',
    icon: REGISTRY_ICONS.FiBarChart2,
    dataSource: 'agentops',
    refreshRate: 60000,
    supportsDateFilter: false
  },
  {
    id: 'cost-per-run',
    name: 'Cost per Run',
    category: C.AGENTOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Average run cost',
    icon: REGISTRY_ICONS.FiDollarSign,
    dataSource: 'agentops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'decision-points',
    name: 'Decision Points',
    category: C.AGENTOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Agent decisions made',
    icon: REGISTRY_ICONS.FiHelpCircle,
    dataSource: 'agentops',
    refreshRate: 60000,
    supportsDateFilter: true
  },
  {
    id: 'human-interventions',
    name: 'Human Interventions',
    category: C.AGENTOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Manual overrides',
    icon: REGISTRY_ICONS.FiUser,
    dataSource: 'agentops',
    refreshRate: 60000,
    supportsDateFilter: true
  },
  {
    id: 'active-agents-count',
    name: 'Active Agents',
    category: C.AGENTOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Deployed agents',
    icon: REGISTRY_ICONS.FiCpu,
    dataSource: 'agentops',
    refreshRate: 300000,
    supportsDateFilter: false
  },
  {
    id: 'run-trends-chart',
    name: 'Run Trends',
    category: C.AGENTOPS,
    type: T.CHART,
    defaultSize: S.LARGE,
    description: 'Runs over time',
    icon: REGISTRY_ICONS.FiTrendingUp,
    dataSource: 'agentops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'tool-success-rate',
    name: 'Tool Success Rate',
    category: C.AGENTOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Tool reliability',
    icon: REGISTRY_ICONS.FiCheckCircle,
    dataSource: 'agentops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'conversation-context-depth',
    name: 'Context Depth',
    category: C.AGENTOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Memory levels tracked',
    icon: REGISTRY_ICONS.FiCpu,
    dataSource: 'agentops',
    refreshRate: 300000,
    supportsDateFilter: false
  },
  {
    id: 'memory-persistence-rate',
    name: 'Memory Persistence',
    category: C.AGENTOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Retained context %',
    icon: REGISTRY_ICONS.FiDatabase,
    dataSource: 'agentops',
    refreshRate: 300000,
    supportsDateFilter: false
  },
  {
    id: 'incident-response-time',
    name: 'Response Time',
    category: C.AGENTOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Time to resolve',
    icon: REGISTRY_ICONS.FiClock,
    dataSource: 'agentops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
];
